import React from 'react';
import {connect} from 'react-redux';
import {Col, Label, Row} from 'reactstrap';
import {AvForm, AvRadio, AvRadioGroup} from 'availity-reactstrap-validation';
import {IRootState} from 'app/shared/reducers';
import {setRegistrationData} from 'app/entities/registration/registration.reducer';
import RegistrationButtons from './registration-buttons';
import 'app/entities/registration/registration.scss';

interface IBypassProps extends StateProps, DispatchProps {
  handlePreviousStep: () => void;
  handleNextStep: () => void;
  currentStep: number;
}

const Bypass = (props: IBypassProps) => {
  const {patientCase} = props;

  const handleEmergencyChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const bypass = e.target.value === 'bypass';
    props.setRegistrationData({
      patientCase: {
        ...patientCase,
        bypass
      }
    });
  };

  const selectedValue = patientCase?.bypass ? 'bypass' : patientCase?.emergency === false ? 'live' : '';

  return (
    <div>
      <h2 className="mb-4">Emergency</h2>
      <AvForm onValidSubmit={props.handleNextStep}>
        <AvRadioGroup name="radio-button-group" required value={selectedValue} errorMessage="Please select an option">
          <Row className="d-flex justify-content-between align-items-center">
            <Col md="6">
              <Label className="radio-button-label">
                <AvRadio
                  name="emergencyType"
                  value="bypass"
                  onClick={handleEmergencyChange}
                  className="radio-button-input"
                />
                Bypass Emergency
              </Label>
            </Col>
            <Col md="6">
              <Label className="radio-button-label">
                <AvRadio
                  name="emergencyType"
                  value="live"
                  onClick={handleEmergencyChange}
                  className="radio-button-input"
                />
                Live Emergency
              </Label>
            </Col>
          </Row>
        </AvRadioGroup>
        <RegistrationButtons
          currentStep={props.currentStep}
          handlePreviousStep={props.handlePreviousStep}
        />
      </AvForm>
    </div>
  );
};

const mapStateToProps = (state: IRootState) => ({
  patientCase: state.registration.entity.patientCase,
});

const mapDispatchToProps = {
  setRegistrationData,
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(Bypass);
